import { render } from "./registerCourtOrder.vue?vue&type=template&id=61d6ac49"
import script from "./registerCourtOrder.vue?vue&type=script&lang=js"
export * from "./registerCourtOrder.vue?vue&type=script&lang=js"

import "./registerCourtOrder.vue?vue&type=style&index=0&id=61d6ac49&lang=css"

import exportComponent from "D:\\proyectos_repositorio_institucional\\ed4\\ed4Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__